export default {
    pageName: 'Overview',
    search: {
        title: '',
        placeholder: 'Search by Employee ID'
    },
    people: 'People',
    detail: {
        title: 'Information',
        present: 'Present',
        late: 'Late',
        halfDay: 'Half-day Absent',
        absent: 'Absent',
        leave: 'Leave'
    },
    header: {
        detail: 'Detail',
        status: 'Status'
    }
}
